import script from "./edit-tabs.vue?vue&type=script&lang=js"
export * from "./edit-tabs.vue?vue&type=script&lang=js"

import "./edit-tabs.vue?vue&type=style&index=0&id=da3256da&lang=scss&scoped=true"

import exportComponent from "/Volumes/kaifa/ApiJavaAdmin/vn-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da3256da"]])

export default __exports__